"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SearchResultKeyboardHint = exports.SearchResultKeyboardHintContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var styled_1 = require("@hiyllo/ux/styled");
var react_native_1 = require("react-native");
var contexts_1 = require("../contexts");
exports.SearchResultKeyboardHintContainer = (0, styled_1.styledRN)(react_native_1.View, {
    padding: 5,
    height: 20,
    minWidth: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderColor: "#ccc",
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: 5,
    marginRight: 5,
    flexGrow: 0
});
var HintText = (0, styled_1.styledRN)(react_native_1.Text, {
    color: "#ccc",
    lineHeight: 10,
    fontSize: 10
});
exports.SearchResultKeyboardHint = react_1["default"].memo(function SearchResultKeyboardHint(props) {
    var inputFocused = react_1["default"].useContext(contexts_1.InputFocusedContext);
    if (react_native_1.Platform.OS !== "web") {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(exports.SearchResultKeyboardHintContainer, { children: (0, jsx_runtime_1.jsxs)(HintText, { children: [props.showTabHint === true && inputFocused ? "Tab + " : "", props.value, inputFocused && props.value === "1" && props.showTabHint === true
                    ? " / Enter"
                    : ""] }) }));
});
